import icon from 'vue-svgicon';

icon.register({
    'regular/wifi-signal-2': {
        width: 16,
        height: 16,
        viewBox: '0 0 24 24',
        data: `<circle pid="0" cx="12" cy="10.319" r="2.25" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/><path pid="1" _fill="none" _stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M12 12.569v9.684M19.286 18.89a11.249 11.249 0 0 0 0-17.143M16.371 15.462a6.749 6.749 0 0 0 0-10.286M4.714 18.89a11.249 11.249 0 0 1 0-17.143M7.629 15.462a6.749 6.749 0 0 1 0-10.286"/>`,
    },
});
